var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      maxWidth: "1000",
      width: "70%",
      height: "600",
      title: _vm.$t("label_essweb_holidayGroup_form_editHolidayBtnLabel"),
      dialog: _vm.show,
    },
    on: { close: _vm.closePorpertyDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                defaultSelect: _vm.PorpertyData,
                items: _vm.desserts,
                itemKey: "uuid",
                showSelect: _vm.showSelect,
              },
              on: {
                select: function (sel) {
                  return (_vm.selected = sel)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "top",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$getCommonLangValue(item.holiday_name)) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.date",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getDateTime(
                              item.holiday_utc_date,
                              "YYYY/MM/DD"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.utc",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$getUtcByCode(item.holiday_time_zone)) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.editPorperty, cancel: _vm.closePorpertyDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }